import styled from "styled-components";
import { Input as AntInput } from "antd";
import { BASE_COLORS, FONT_SIZE_PX } from "config/theme/constants";

export const InputPassword = styled(AntInput.Password)`
  .ant-input-password-icon.anticon {
    font-size: ${FONT_SIZE_PX.xxxxxl};
    color: ${BASE_COLORS.dustyGray};
    &:hover {
      color: ${BASE_COLORS.dustyGray};
    }
  }
`;
